import React from "react";
import { Link } from "react-router-dom"; 
import "bootstrap/dist/css/bootstrap.min.css";
import logo from '../Ecomphotos/ori.png';

// Icons Import
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import { IoLocationSharp, IoCall, IoMail, IoChevronForward } from "react-icons/io5";

// import "./Footer.css"; // Custom CSS file

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div className="container">
        
        {/* --- Top Section (Widgets) --- */}
        <div className="row pt-5 pb-4">
          
          {/* Column 1: Brand Info */}
          <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
            <Link to="/" className="d-block mb-3">
              <img src={logo} className="img-fluid footer-logo" alt="Jawali Holidays" />
            </Link>
            <p className="footer-desc">
              Your trusted partner for memorable journeys. From the deserts of Rajasthan 
              to the hills of Himachal, we make every trip special.
            </p>
            {/* Social Icons */}
            <div className="social-links mt-4">
              <a href="https://www.instagram.com/jawaliholidays?igsh=MTJ3MXRwOXoxNnN1aw==" target="_blank" rel="noreferrer"><FaInstagram /></a>
              <a href="https://wa.me/919828074121" target="_blank" rel="noreferrer"><FaWhatsapp /></a>
            </div>
          </div>

          {/* Column 2: Quick Links (Internal Navigation) */}
          <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
            <h5 className="footer-heading">Quick Links</h5>
            <ul className="list-unstyled footer-links">
              <li><Link to="/"><IoChevronForward className="icon-arrow"/> Home</Link></li>
              <li><Link to="/about"><IoChevronForward className="icon-arrow"/> About Us</Link></li>
              <li><Link to="/packages"><IoChevronForward className="icon-arrow"/> Packages</Link></li>
              <li><Link to="/contact"><IoChevronForward className="icon-arrow"/> Contact</Link></li>
            </ul>
          </div>

          {/* Column 3: Popular Tours (SEO & Navigation) */}
          <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
            <h5 className="footer-heading">Destinations</h5>
            <ul className="list-unstyled footer-links">
              <li><Link to="/Rajasthan"><IoChevronForward className="icon-arrow"/> Rajasthan</Link></li>
              <li><Link to="/Kashmir"><IoChevronForward className="icon-arrow"/> Kashmir</Link></li>
              <li><Link to="/Himachal"><IoChevronForward className="icon-arrow"/> Himachal</Link></li>
              <li><Link to="/Kerala"><IoChevronForward className="icon-arrow"/> Kerala</Link></li>
            </ul>
          </div>

          {/* Column 4: Contact Info (External Actions) */}
          <div className="col-lg-4 col-md-6">
            <h5 className="footer-heading">Get In Touch</h5>
            <ul className="list-unstyled contact-info">
              <li>
                <div className="d-flex">
                  <span className="icon-box"><IoLocationSharp /></span>
                  <span className="ms-3 text-secondary">125-A-1, Shop No. 03, 1st B Road,
Sardarpura, Jodhpur, Rajasthan</span>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-center">
                  <span className="icon-box"><IoCall /></span>
                  {/* Click to Call */}
                  <a href="tel:+919828074121" className="ms-3 text-secondary text-decoration-none hover-highlight">
                    +91 98280-74121
                  </a>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-center">
                  <span className="icon-box"><IoMail /></span>
                  {/* Click to Email */}
                  <a href="mailto:jawaliholidays@gmail.com" className="ms-3 text-secondary text-decoration-none hover-highlight">
                    jawaliholidays@gmail.com
                  </a>
                </div>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* --- Bottom Copyright Section --- */}
      <div className="copyright-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start">
              <p className="mb-0 small">
                &copy; {currentYear} <strong className="text-white">Jawali Holidays</strong>. All Rights Reserved.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end mt-2 mt-md-0">
              <Link to="/privacy" className="bottom-link">Privacy Policy</Link>
              <span className="mx-2 text-muted">|</span>
              <Link to="/terms" className="bottom-link">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
    
  );
}